import {
  Http,
  Auth,
  Storage,
  GraphQlClient,
} from '@intelipost-js/secure-providers';

export default {
  getReports({ commit }) {
    const reports = Storage.get('biReports');
    if (reports) {
      return commit('setReports', reports);
    }

    commit('setLoading', true);

    return GraphQlClient.query(`
    query{
      biReports{
        id
        title
        url
      }
    }`)
      .then((res) => {
        const {
          data: {
            biReports = [],
          },
        } = res;

        if (Array.isArray(biReports)) {
          Storage.set('biReports', biReports);
          commit('setReports', biReports);
        }

        commit('setLoading', false);
        return Promise.resolve(biReports);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
  getSessionReport({ dispatch }) {
    const {
      biSessionToken,
    } = Auth.getUser();

    if (biSessionToken) {
      return Promise.resolve();
    }

    return GraphQlClient.query(`
    query{
      biSessionToken{
        token
      }
    }`)
      .then((res) => {
        const {
          data: {
            biSessionToken: {
              token,
            } = {},
          } = {},
        } = res;

        Auth.updateUser({ biSessionToken: token });

        return dispatch('loginOneLogin', token);
      });
  },
  loginOneLogin(context, session_token) {
    return Http.request({
      baseURL: process.env.ONE_LOGIN_URL,
      url: 'session_via_api_token',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        session_token,
      },
      withCredentials: true,
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/bi-reports/store/actions.js